import { render, staticRenderFns } from "./Main3.vue?vue&type=template&id=78f608e1&scoped=true&"
import script from "./Main3.vue?vue&type=script&lang=js&"
export * from "./Main3.vue?vue&type=script&lang=js&"
import style0 from "./Main3.vue?vue&type=style&index=0&id=78f608e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f608e1",
  null
  
)

export default component.exports